import React, { useState } from "react";
import { Collapse, Tag } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

/**
 * Ghi chú cho người trực admin (không rành code).
 *
 * Viết theo câu hỏi thật họ sẽ hỏi khi nhìn bảng — "mã 01a0f511 này để làm gì?" —
 * chứ không phải bài giảng về OTA. Ngắn, câu ngắn, không thuật ngữ.
 *
 * Mặc định MỞ cho người lần đầu vào tab; ai đã tự đóng thì lần sau giữ đóng
 * (nhớ qua localStorage) để khỏi chiếm chỗ của bảng số liệu.
 */

const STORAGE_KEY = "ota-explainer-collapsed";

const readCollapsed = () => {
    try {
        return localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
        // Safari chế độ riêng tư chặn localStorage — coi như chưa đóng lần nào.
        return false;
    }
};

const writeCollapsed = (collapsed) => {
    try {
        localStorage.setItem(STORAGE_KEY, collapsed ? "1" : "0");
    } catch {
        /* không lưu được thì thôi, không ảnh hưởng hiển thị */
    }
};

function OtaRolloutExplainer() {
    const [openKeys, setOpenKeys] = useState(() => (readCollapsed() ? [] : ["what-is-ota"]));

    const onChange = (keys) => {
        setOpenKeys(keys);
        writeCollapsed(keys.length === 0);
    };

    const content = (
        <div className="text-sm">
            <p className="m-0 mb-3">
                Kỹ thuật sửa lỗi xong có thể gửi <b>bản vá</b> thẳng vào app, user không phải ra
                store tải lại. Mỗi bản vá được đánh <b>một mã riêng</b> như{" "}
                <code>01a0f511</code> — giống số lô hàng.
            </p>

            <div className="font-semibold mb-1">Mã đó để làm gì?</div>
            <ul className="list-disc pl-4 m-0 mb-3">
                <li>
                    Cột <b>Bản này sửa gì</b> ngay bên cạnh cho biết bản vá đó sửa chuyện gì — không
                    cần hỏi kỹ thuật.
                </li>
                <li>
                    Biết <b>máy user đang chạy bản nào</b>. User kêu lỗi mà máy còn mã cũ → bảo họ
                    tắt mở lại app là nhận bản mới.
                </li>
                <li>
                    Biết <b>bản vá mới đã về được bao nhiêu máy</b> — càng nhiều máy cùng mã mới
                    càng tốt.
                </li>
            </ul>

            <div className="font-semibold mb-1">Nhãn trong bảng</div>
            <ul className="list-disc pl-4 m-0 mb-3">
                <li>
                    <Tag color="green">OTA</Tag> đã nhận bản vá.
                </li>
                <li>
                    <Tag color="blue">Bản gốc trong app</Tag> chưa nhận bản vá nào, vẫn là bản tải
                    từ store.
                </li>
                <li>
                    <Tag>Bản cũ (chưa báo)</Tag> app quá cũ, không gửi mã về được → chắc chắn chưa
                    có bản vá.
                </li>
            </ul>

            <div className="font-semibold mb-1">Nhớ 3 ý</div>
            <ul className="list-disc pl-4 m-0">
                <li>Chỉ đếm máy <b>có mở app</b> trong kỳ — chưa mở thì không thể nhận bản vá.</li>
                <li>
                    Vừa đẩy bản vá thì ô <b>Đã nhận OTA</b> tăng dần, 1–2 ngày phủ phần lớn. Đứng im
                    mãi → báo kỹ thuật.
                </li>
                <li>
                    Bản vá <b>không làm đổi version trên store</b> (vẫn 1.7.0). Hai số đó không so
                    với nhau được.
                </li>
            </ul>

            <div className="text-xs text-content-3 border-t border-line pt-2 mt-3">
                Dành cho kỹ thuật: đối chiếu mã bundle bằng <code>npx hot-updater bundle list</code>;
                mã này cũng hiện ở màn Tài khoản trong app.
            </div>
        </div>
    );

    return (
        <Collapse
            className="mb-4"
            activeKey={openKeys}
            onChange={onChange}
            items={[
                {
                    key: "what-is-ota",
                    label: (
                        <span className="font-medium">
                            <FontAwesomeIcon icon={faCircleInfo} className="mr-2 text-blue-500" />
                            Mã bundle (vd <code>01a0f511</code>) là gì, để làm gì?
                        </span>
                    ),
                    children: content,
                },
            ]}
        />
    );
}

export default OtaRolloutExplainer;
